/*
  ヘッダーの検索（虫眼鏡）で、1文字目から下に商品の候補を出す（松本様ご指示 2026-10-12）。
  Shopify標準の候補表示は日本語のお店では動かないため（/search/suggest が「Unsupported buyer locale」）、
  templates/collection.lf-search-index.liquid の商品一覧を、検索欄を初めて触ったときに1回だけ読み、その中から探す。
  探す先：商品名（品番を含む）・タグ・素材・カテゴリー・カラー。ひらがなはカタカナに直し、英語のモチーフ名にはカタカナの読みも足す。
  上に「キーワード」（カテゴリー・モチーフ・素材・カラー。押すとその一覧へ）を最大5件出し、
  「シルバーネックレス」「メンズネックレス」のようなつなげた言葉は分けて、組み合わせの候補（ネックレス × シルバー）にする。
  その下に「○○の商品をすべて見る（N件）」の1行（件数は商品名・タグなどに当たる数）。
  商品そのもの（画像つき）は、ごちゃつくので出さない（松本様 2026-10-12「ごちゃついてる」）。
  ただし品番（R11・#N63 など）を打ったときだけ、その商品を出す（ちょうど合う1件、なければ品番の頭が合うもの最大3件）。
  その下に、ジャーナルの記事（templates/blog.lf-search-index.liquid）から「読みもの」を最大2件、2文字目から出す
  （松本様 2026-10-12「ジャーナルも検索で拾われた方が」。サイズ・金属アレルギー・お手入れなどの記事に案内する）。
  Enter は今までどおり検索結果ページへ。
  出す場所はテーマ標準の #predictive-search（.search__results）。テーマの候補表示の設定はオフのままなので、ぶつからない。
*/
(function() {
  if (window.lfSearchSuggest) return;
  window.lfSearchSuggest = true;

  var INDEX_URL = '/collections/all?view=lf-search-index&sort_by=best-selling';
  var CACHE_KEY = 'lfSearchIndex:v1';
  var ARTICLES_URL = '/blogs/journal?view=lf-search-index';
  var ARTICLES_CACHE_KEY = 'lfSearchArticles:v1';
  var MAX_CODE = 3;
  var MAX_WORDS = 5;
  var MAX_ARTICLES = 2;

  // キーワード：w=出す言葉、r=当てる読み（ひらがな・英語・漢字・よくある打ち間違い）、u=押したときの行き先、
  // q=商品を探すときの言葉（商品名・タグに入っている言葉）。
  // cat=カテゴリーの一覧、f=一覧に付ける絞り込み（カラー・素材）。「シルバーネックレス」のような組み合わせで使う。
  // 読みは、実際によく検索されている言葉（2026-10-12 時点の直近90日の検索ワード上位100）を見て足した。
  var COLOR = 'filter.v.option.%E3%82%AB%E3%83%A9%E3%83%BC=';
  var MATERIAL = 'filter.p.m.custom.material=gid%3A%2F%2Fshopify%2FFilterSettingGroup%2F';
  var WORDS = [
    { w: 'ネックレス', r: 'ねっくれす necklace ぺんだんと ぺんだんとtop ぺんだんととっぷ pendant', u: '/collections/necklace', q: 'necklace', cat: 'necklace' },
    { w: 'リング', r: 'りんぐ ring 指輪 ゆびわ', u: '/collections/ring', q: 'ring', cat: 'ring' },
    { w: 'ピンキーリング', r: 'ぴんきーりんぐ ぴんきー pinky 小指', u: '/collections/pinky', q: 'pinky', cat: 'pinky' },
    { w: 'ブレスレット', r: 'ぶれすれっと ぶれすれっど ぶれす bracelet', u: '/collections/bracelet', q: 'bracelet', cat: 'bracelet' },
    { w: 'バングル', r: 'ばんぐる bangle', u: '/collections/bangle', q: 'bangle', cat: 'bangle' },
    { w: 'ピアス', r: 'ぴあす pierce earring いやりんぐ', u: '/collections/pierce', q: 'pierce', cat: 'pierce' },
    { w: 'イヤーカフ', r: 'いやーかふ earcuff いやりんぐ', u: '/collections/earcuff', q: 'earcuff', cat: 'earcuff' },
    { w: 'アンクレット', r: 'あんくれっと anklet', u: '/collections/anklet', q: 'anklet', cat: 'anklet' },
    { w: 'キーリング', r: 'きーりんぐ きーほるだー きーちぇーん からびな うぉれっとちぇーん うぉれっと keyring carabiner wallet', u: '/collections/key-ring', q: 'key', cat: 'key-ring' },
    { w: 'ハワイアン', r: 'はわいあん hawaiian', u: '/collections/hawaiian', q: 'hawaiian' },
    { w: 'ホースシュー（馬蹄）', r: 'ほーすしゅー ばてい 馬蹄 horseshoe', u: '/collections/horseshoe', q: 'horseshoe' },
    { w: 'スター（星）', r: 'すたー ほし 星 star', u: '/collections/star', q: 'star' },
    { w: 'サン（太陽）', r: 'さん たいよう 太陽 sun', u: '/collections/sun', q: 'sun' },
    { w: 'フェザー', r: 'ふぇざー はね 羽 feather', u: '/collections/feather', q: 'feather' },
    { w: 'コイン', r: 'こいん めだい coin medai', u: '/collections/coin', q: 'coin' },
    { w: 'シグネット', r: 'しぐねっと いんだい 印台 signet', u: '/collections/signet', q: 'signet' },
    { w: 'アンカー', r: 'あんかー いかり 錨 anchor', u: '/collections/anchor-motif-collection', q: 'anchor' },
    { w: 'クロス（十字架）', r: 'くろす じゅうじか 十字架 cross', u: '/search?type=product&q=cross', q: 'cross' },
    { w: 'チェーン', r: 'ちぇーん chain', u: '/search?type=product&q=chain', q: 'chain' },
    { w: 'フープピアス', r: 'ふーぷ hoop', u: '/search?type=product&q=hoop', q: 'hoop' },
    { w: 'ハート', r: 'はーと heart', u: '/search?type=product&q=heart', q: 'heart' },
    { w: 'パール', r: 'ぱーる 真珠 しんじゅ pearl', u: '/search?type=product&q=pearl', q: 'pearl' },
    { w: 'ブラック', r: 'ぶらっく 黒 くろ black', u: '/search?type=product&q=black', q: 'black' },
    { w: 'シルバー925', r: 'しるばー925 s925 sv925 s952 925 silver925 すてるりんぐしるばー', u: '/collections/s925', q: 's925', f: MATERIAL + '129663020' },
    { w: 'サージカルステンレス', r: 'さーじかるすてんれす さーじかる すてんれす 316l 316 stainless', u: '/collections/all?' + MATERIAL + '129597484', q: '316l', f: MATERIAL + '129597484' },
    { w: 'ゴールド', r: 'ごーるど きん 金 gold 18k', u: '/collections/all?' + COLOR + 'GOLD', q: 'gold', f: COLOR + 'GOLD' },
    { w: 'シルバー', r: 'しるばー ぎん 銀 silver', u: '/collections/all?' + COLOR + 'SILVER', q: 'silver', f: COLOR + 'SILVER' },
    { w: 'ペア', r: 'ぺあ pair おそろい', u: '/search?type=product&q=pair', q: 'pair' },
    { w: '新作', r: 'しんさく 新作 new にゅー', u: '/collections/new-arrival' },
    { w: 'ギフトバッグ（ラッピング）', r: 'ぎふと ぎふとばっぐ らっぴんぐ ぷれぜんと 包装 gift', u: '/products/gift-bag-h1' },
    { w: 'すべての商品', r: 'めんず れでぃーす あくせさりー じゅえりー 男性 女性 all', u: '/collections/all', skip: true },
    { w: 'マイページ（ログイン）', r: 'まいぺーじ ろぐいん 会員 account', u: '/account', skip: true }
  ];
  // 組み合わせのときに無視する言葉（どの商品にも当てはまる言葉）
  var STOP = ['メンズ', 'レディース', 'アクセサリー', 'ジュエリー', '男性', '女性', 'mens'];

  // 英語の名前 → お客様が打ちそうなカタカナ・漢字
  var ALIASES = {
    necklace: 'ネックレス', ring: 'リング 指輪', bracelet: 'ブレスレット', bangle: 'バングル', pierce: 'ピアス',
    anklet: 'アンクレット', earcuff: 'イヤーカフ', keyring: 'キーリング キーホルダー', 'key ring': 'キーリング キーホルダー',
    chain: 'チェーン', pinky: 'ピンキー', signet: 'シグネット 印台', horseshoe: 'ホースシュー 馬蹄', cross: 'クロス 十字架',
    coin: 'コイン', medai: 'メダイ', anchor: 'アンカー 錨', feather: 'フェザー 羽', fether: 'フェザー 羽', star: 'スター 星',
    sun: 'サン 太陽', hawaiian: 'ハワイアン', hawaian: 'ハワイアン', zirconia: 'ジルコニア', heart: 'ハート', wave: 'ウェーブ 波',
    gold: 'ゴールド 金', silver: 'シルバー 銀', pair: 'ペア', twist: 'ツイスト', hoop: 'フープ', smile: 'スマイル'
  };

  var index = null;
  var loading = null;

  function kana(s) {
    // ひらがな → カタカナ、全角英数 → 半角、小文字に
    return s
      .replace(/[ぁ-ゖ]/g, function(c) { return String.fromCharCode(c.charCodeAt(0) + 0x60); })
      .replace(/[Ａ-Ｚａ-ｚ０-９＃]/g, function(c) { return String.fromCharCode(c.charCodeAt(0) - 0xFEE0); })
      .toLowerCase();
  }

  function build(items) {
    return items.map(function(item) {
      var text = kana(item.t + ' ' + item.k);
      var extra = [];
      Object.keys(ALIASES).forEach(function(en) {
        if (text.indexOf(en) > -1) extra.push(ALIASES[en]);
      });
      item.title = kana(item.t);
      item.text = text + ' ' + kana(extra.join(' '));
      return item;
    });
  }

  function load() {
    if (index) return Promise.resolve(index);
    if (loading) return loading;
    try {
      var cached = sessionStorage.getItem(CACHE_KEY);
      if (cached) {
        index = build(JSON.parse(cached));
        return Promise.resolve(index);
      }
    } catch (e) {}
    loading = fetch(INDEX_URL, { credentials: 'same-origin' })
      .then(function(r) { return r.text(); })
      .then(function(text) {
        var items = JSON.parse(text);
        try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(items)); } catch (e) {}
        index = build(items);
        return index;
      })
      .catch(function() { loading = null; return []; });
    return loading;
  }

  // ジャーナルの記事一覧（商品と同じく1回だけ読み、タブを閉じるまで覚えておく）
  var articles = null;
  var loadingArticles = null;
  function loadArticles() {
    if (articles) return Promise.resolve(articles);
    if (loadingArticles) return loadingArticles;
    function prepare(items) {
      return items.map(function(item) {
        item.title = kana(item.t);
        item.text = kana(item.t + ' ' + item.k);
        return item;
      });
    }
    try {
      var cached = sessionStorage.getItem(ARTICLES_CACHE_KEY);
      if (cached) {
        articles = prepare(JSON.parse(cached));
        return Promise.resolve(articles);
      }
    } catch (e) {}
    loadingArticles = fetch(ARTICLES_URL, { credentials: 'same-origin' })
      .then(function(r) { return r.text(); })
      .then(function(text) {
        var items = JSON.parse(text);
        try { sessionStorage.setItem(ARTICLES_CACHE_KEY, JSON.stringify(items)); } catch (e) {}
        articles = prepare(items);
        return articles;
      })
      .catch(function() { loadingArticles = null; return []; });
    return loadingArticles;
  }

  // 読みもの：1文字だとほとんどの記事に当たるので2文字目から。タイトルに入っているものを先に、あとは新しい順
  function searchArticles(query) {
    var terms = kana(query).split(/\s+/).filter(Boolean);
    if (!articles || terms.join('').length < 2) return [];
    var hits = [];
    articles.forEach(function(item, order) {
      var score = 0;
      for (var i = 0; i < terms.length; i++) {
        if (item.text.indexOf(terms[i]) === -1) return;
        score += item.title.indexOf(terms[i]) > -1 ? 2 : 1;
      }
      hits.push({ item: item, score: score, order: order });
    });
    hits.sort(function(a, b) { return b.score - a.score || a.order - b.order; });
    return hits.slice(0, MAX_ARTICLES).map(function(hit) { return hit.item; });
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function(c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // 言葉の頭（空白・記号・#の直後、または先頭）に合うか
  function startsWord(text, term) {
    var i = text.indexOf(term);
    while (i > -1) {
      if (i === 0 || /[\s#(（\-_/、]/.test(text.charAt(i - 1))) return true;
      i = text.indexOf(term, i + 1);
    }
    return false;
  }

  function search(query, retry) {
    var terms = kana(query).split(/\s+/).filter(Boolean);
    if (!terms.length || !index) return [];
    var hits = [];
    index.forEach(function(item, order) {
      var score = 0;
      for (var i = 0; i < terms.length; i++) {
        var t = terms[i];
        if (item.text.indexOf(t) === -1) return;
        if (startsWord(item.title, t)) score += 3;
        else if (startsWord(item.text, t)) score += 2;
        else score += 1;
      }
      hits.push({ item: item, score: score, order: order });
    });
    hits.sort(function(a, b) { return b.score - a.score || a.order - b.order; });
    if (!hits.length && !retry) {
      var parts = segment(query);
      if (parts && parts.every(function(w) { return w.q; })) {
        var again = search(parts.map(function(w) { return w.q; }).join(' '), true);
        again.usedQuery = parts.map(function(w) { return w.q; }).join(' ');
        return again;
      }
    }
    return hits;
  }

  // キーワード：読みの頭が合うものを先に、次に途中に含むもの
  function searchWords(query) {
    var q = kana(query).replace(/\s+/g, '');
    if (!q) return [];
    var head = [], inner = [];
    WORDS.forEach(function(word) {
      var isHead = false, isIn = false;
      keysOf(word).forEach(function(k) {
        if (k.indexOf(q) === 0) isHead = true;
        else if (k.indexOf(q) > 0) isIn = true;
      });
      if (isHead) head.push(word);
      else if (isIn) inner.push(word);
    });
    var list = head.concat(inner);
    // 「シルバーネックレス」「s925 ネックレス」「メンズネックレス」のように言葉をつなげて打ったとき
    if (!list.length) {
      var parts = segment(query);
      if (parts) list = combine(parts);
    }
    return list.slice(0, MAX_WORDS);
  }

  function keysOf(word) {
    if (!word.keys) word.keys = kana(word.w.replace(/[（）]/g, ' ') + ' ' + word.r).split(/\s+/).filter(Boolean);
    return word.keys;
  }

  // 打った言葉を、キーワードの読みに分ける（長い読みから先に当てる）。分けきれなければ null
  var SEG_KEYS = null;
  function segment(query) {
    if (!SEG_KEYS) {
      SEG_KEYS = [];
      WORDS.forEach(function(word) {
        if (word.skip) return;
        keysOf(word).forEach(function(k) { if (k.length >= 2) SEG_KEYS.push({ k: k, word: word }); });
      });
      SEG_KEYS.sort(function(a, b) { return b.k.length - a.k.length; });
    }
    var rest = kana(query);
    STOP.forEach(function(w) { rest = rest.split(kana(w)).join(' '); });
    var found = [];
    SEG_KEYS.forEach(function(sk) {
      if (rest.indexOf(sk.k) > -1) {
        rest = rest.split(sk.k).join(' ');
        if (found.indexOf(sk.word) === -1) found.push(sk.word);
      }
    });
    if (!found.length || rest.replace(/\s+/g, '')) return null;
    return found;
  }

  // 分けたキーワードを、押せる候補にする。
  // カテゴリー＋カラー・素材 → そのカテゴリーの一覧を絞り込んだもの（例：ネックレス × シルバー925）。
  // それ以外の組み合わせ → その言葉で検索（例：コイン × ネックレス）。1つだけならそのキーワード。
  function combine(found) {
    if (found.length === 1) return found;
    var cat = found.filter(function(w) { return w.cat; })[0];
    var filters = found.filter(function(w) { return w.f; });
    var others = found.filter(function(w) { return !w.cat && !w.f; });
    var label = found.map(function(w) { return w.w.replace(/（.*）/, ''); }).join(' × ');
    var url;
    if (cat && filters.length && !others.length && found.length === filters.length + 1) {
      url = '/collections/' + cat.cat + '?' + filters.map(function(w) { return w.f; }).join('&');
    } else {
      url = searchUrl(found.map(function(w) { return w.q || w.w; }).join(' '));
    }
    return [{ w: label, u: url, parts: found }].concat(found);
  }

  // 品番（英字1〜2文字＋数字。# や空白・ハイフンはあってもよい）を打ったときだけ、その商品を出す
  function searchCode(query) {
    var q = kana(query).replace(/[\s#\-]/g, '');
    if (!index || !/^[a-z]{1,2}\d{1,3}$/.test(q) || /^(s|sv)9\d\d$/.test(q)) return [];
    var exact = [], head = [];
    index.forEach(function(item) {
      var m = item.title.match(/#\s*([a-z]{1,2}\d{1,3})/);
      if (!m) return;
      if (m[1] === q) exact.push(item);
      else if (m[1].indexOf(q) === 0) head.push(item);
    });
    return exact.length ? exact.slice(0, 1) : head.slice(0, MAX_CODE);
  }

  function searchUrl(query) {
    return '/search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(query);
  }

  function render(box, query, hits) {
    var words = searchWords(query);
    var reads = searchArticles(query);
    var codes = searchCode(query);
    var html = '<div class="lf-suggest">';
    if (words.length) {
      html += '<p class="lf-suggest__label">キーワード</p><ul class="lf-suggest__words">';
      words.forEach(function(word) {
        html += '<li><a class="lf-suggest__word" href="' + word.u + '">' +
          '<svg aria-hidden="true" focusable="false" viewBox="0 0 64 64"><path d="M47.16 28.58A18.58 18.58 0 1 1 28.58 10a18.58 18.58 0 0 1 18.58 18.58ZM54 54 41.94 42"/></svg>' +
          escapeHtml(word.w) + '</a></li>';
      });
      html += '</ul>';
    }
    if (codes.length) {
      html += '<p class="lf-suggest__label">商品</p><ul class="lf-suggest__list">';
      codes.forEach(function(p) {
        html += '<li><a class="lf-suggest__item" href="' + escapeHtml(p.u) + '">' +
          (p.i ? '<img class="lf-suggest__img" src="' + escapeHtml(p.i) + '" alt="" width="48" height="48" loading="lazy">' : '<span class="lf-suggest__img"></span>') +
          '<span class="lf-suggest__name">' + escapeHtml(p.t) + '</span>' +
          '<span class="lf-suggest__price">' + escapeHtml(p.p) + '</span></a></li>';
      });
      html += '</ul>';
    }
    if (hits.length) {
      var combo = words.filter(function(w) { return w.parts; })[0];
      var allUrl = combo ? combo.u : searchUrl(hits.usedQuery || query);
      html += '<a class="lf-suggest__all" href="' + allUrl + '">「' + escapeHtml(query) + '」の商品をすべて見る（' + hits.length + '件）</a>';
    }
    if (reads.length) {
      html += '<p class="lf-suggest__label">読みもの</p><ul class="lf-suggest__reads">';
      reads.forEach(function(item) {
        html += '<li><a class="lf-suggest__read" href="' + escapeHtml(item.u) + '">' + escapeHtml(item.t) + '</a></li>';
      });
      html += '</ul>';
    }
    if (hits.length) {
      // 商品があるときは上で「すべて見る」を出している
    } else if (!words.length && !reads.length) {
      html += '<p class="lf-suggest__none">候補が見つかりません</p>';
      html += '<a class="lf-suggest__all" href="' + searchUrl(query) + '">「' + escapeHtml(query) + '」で検索する</a>';
    } else {
      html += '<a class="lf-suggest__all" href="' + searchUrl(query) + '">「' + escapeHtml(query) + '」で検索する</a>';
    }
    html += '</div>';
    box.innerHTML = html;
    box.style.display = 'block';
  }

  function hide(box) {
    box.style.display = 'none';
    box.innerHTML = '';
  }

  function setup(el) {
    var input = el.querySelector('input[type="search"]');
    var box = el.querySelector('#predictive-search, .search__results');
    if (!input || !box || input.dataset.lfSuggest) return;
    input.dataset.lfSuggest = '1';

    var timer;
    function update() {
      var query = input.value.trim();
      if (!query) { hide(box); return; }
      Promise.all([load(), loadArticles()]).then(function() {
        if (input.value.trim() !== query) return;
        render(box, query, search(query));
      });
    }
    input.addEventListener('focus', function() { load(); loadArticles(); });
    input.addEventListener('input', function() {
      clearTimeout(timer);
      timer = setTimeout(update, 80);
    });
    input.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') hide(box);
    });
    // 検索を閉じたら候補も消す（テーマの閉じる処理）
    document.addEventListener('predictive-search:close-all', function() { hide(box); });
  }

  function init() {
    document.querySelectorAll('predictive-search').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
